// src/features/inventory/components/InventoryExcelImportModal.jsx

import React, { useState } from "react";
import { useInventoryStore } from "../../../store/useInventoryStore";
import { parseExcelFile, mapExcelToInventory } from "../../../utils/inventory/inventoryExcel";

const InventoryExcelImportModal = ({ open, onClose }) => {
  const {
    setBulkPreviewRows,
    openBulkPreview,
  } = useInventoryStore();

  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState("");

  if (!open) return null;

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setFileName(file.name);
    setLocalError("");
    setLoading(true);

    try {
      const rawRows = await parseExcelFile(file);
      const mappedRows = mapExcelToInventory(rawRows);

      if (!mappedRows.length) {
        setLocalError("هیچ ردیف معتبری از فایل اکسل استخراج نشد.");
        return;
      }

      setBulkPreviewRows(mappedRows);
      openBulkPreview();
    } catch (error) {
      setLocalError(error?.message || "خطا در پردازش فایل اکسل.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg rounded-xl bg-white p-5 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-bold">ورود موجودی از اکسل</h3>
          <button type="button" onClick={onClose} className="text-gray-500">
            ✕
          </button>
        </div>

        <div className="space-y-4">
          <div className="rounded-lg border border-dashed p-4">
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              className="block w-full text-sm"
            />
            {fileName ? (
              <div className="mt-2 text-xs text-gray-500">فایل انتخاب‌شده: {fileName}</div>
            ) : null}
          </div>

          {loading && (
            <div className="text-sm text-gray-500">در حال خواندن و پردازش فایل...</div>
          )}

          {localError ? (
            <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
              {localError}
            </div>
          ) : null}

          <div className="rounded-lg bg-gray-50 p-3 text-xs text-gray-600">
            فایل اکسل باید شامل ستون‌های استاندارد مانند شناسه، قیمت، موجودی، درصد تخفیف،
            حداقل سفارش، حداکثر سفارش و مضرب سفارش باشد.
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryExcelImportModal;
